import React, { useEffect, useState } from "react";
import { useNavigation, useAuth } from "react-uicomp";
import Select from "react-select";

// ACTIONs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getNewsLetterAction,
  deleteNewsLetterAction,
  getResearchProgramAction,
} from "../../actions/Actions";

// HOCS
import CompWrapper from "../hocs/CompWrapper.hoc";

// COMMON
import { InvertedButton } from "../common/button/Button.common";
import Table from "../common/table/Table.common";

// HELPER
import { FILE_URL } from "../../config/Config";

const NewsLetterPage = (props) => {
  const {
    getNewsLetterAction,
    deleteNewsLetterAction,
    newsLetter,
    getResearchProgramAction,
    researchProgram,
  } = props;

  const { listLoader, listCount, list, deleteLoader } = newsLetter;
  const { listResearchPorgram } = researchProgram;
  const { location, navigation } = useNavigation();
  const { toast } = useAuth();

  const [researchProgramOption, setResearchProgramOption] = useState([]);
  const [selectedResearchProgram, setSelectedResearchProgram] = useState([]);

  const { navigate, routes } = navigation;
  let query = useQuery();

  function useQuery() {
    return new URLSearchParams(location?.search);
  }
  const pageNumber = query.get("page") || 1;

  useEffect(() => {
    getNewsLetterAction(pageNumber, selectedResearchProgram?.id);
  }, [getNewsLetterAction, pageNumber, selectedResearchProgram]);

  const deleteHandler = (id) => {
    deleteNewsLetterAction(id, toast, pageNumber);
  };

  const editHandler = (id) => {
    navigate(`news-letter/edit/${id}`);
  };

  const handleResearchProgram = (selectedOptions) => {
    setSelectedResearchProgram(selectedOptions);
    navigate(location.pathname + `?page=` + Number(1));
    getNewsLetterAction(pageNumber, selectedOptions?.id);
  };

  useEffect(() => {
    const remappedResearchProgramList = listResearchPorgram?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );

    const allappendedResearchProgramList = [
      { id: 0, label: "All", value: "" },
      ...remappedResearchProgramList,
    ];
    setResearchProgramOption(allappendedResearchProgramList);
  }, [listResearchPorgram]);

  useEffect(() => {
    getResearchProgramAction(1);
  }, [getResearchProgramAction]);

  return (
    <CompWrapper>
      <div className="newspage-container">
        <div className="newspage">
          <div className="newspage-head">
            <div className="newspage-head-title">News Letter</div>

            <Select
              isMulti={false}
              options={researchProgramOption}
              value={selectedResearchProgram}
              onChange={handleResearchProgram}
              placeholder="Select Research Program"
            />

            <div className="newspage-head-button">
              <div style={{ width: 100 }}>
                <InvertedButton
                  title="Add"
                  onClick={() => {
                    navigate(routes["Add NewsLetter"].path);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="newspage-list">
            <Table
              columns={[
                {
                  field: "thumbnail",
                  render: (rowData) => (
                    <img
                      alt="thumbnail"
                      src={FILE_URL + rowData}
                      style={{ height: 100, borderRadius: 4 }}
                    />
                  ),
                },
                {
                  field: "description",
                  name: "title",
                  render: (rowData) => <p>{rowData?.title?.en}</p>,
                },
                {
                  field: "description",
                  render: (rowData) => <p>{rowData?.shortDesc?.en}</p>,
                },
                {
                  field: "description",
                  name: "date",
                  render: (rowData) => <p>{rowData?.date?.en}</p>,
                },
              ]}
              data={list}
              actions
              dataLoader={listLoader}
              totalCount={listCount}
              deleteLoader={deleteLoader}
              onDeleteHandler={deleteHandler}
              onEditHandler={editHandler}
            />
          </div>
        </div>
      </div>
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    newsLetter: state.newsLetter,
    researchProgram: state.researchProgram,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getNewsLetterAction,
      deleteNewsLetterAction,
      getResearchProgramAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsLetterPage);
